/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type AdherencePredictionComputedJournalEvent from "parog-web/models/adherence-prediction-computed-journal-event";
import type HospitalisationRiskPredictionComputedJournalEvent from "parog-web/models/hospitalisation-risk-prediction-computed-journal-event";
import type ToxicityPredictionComputedJournalEvent from "parog-web/models/toxicity-prediction-computed-journal-event";

import styles from "./index.module.css";

interface Signature {
  Args: {
    predictionComputedJe:
      | AdherencePredictionComputedJournalEvent
      | ToxicityPredictionComputedJournalEvent
      | HospitalisationRiskPredictionComputedJournalEvent;
    riskType: string;
  };
}

export default class PredictionRiskScoreComponent extends Component<Signature> {
  styles = styles;

  get scoreCategory(): string | undefined {
    return (
      this.args.predictionComputedJe?.[`${this.args.riskType}ScoreCategory`] ||
      "inconnu"
    );
  }

  get scoreCategoryColor(): string {
    switch (this.scoreCategory) {
      case "faible":
        return "green";
      case "moyen":
        return "orange";
      case "élevé":
        return "red";
      default:
        return "brown";
    }
  }
}
